module.exports = "../study/imgs/maps/Kanagawa/GWQ8/Climate/SummerDay/Kanagawa_SummerDay_MRI_RCP85_End.png";